import React from "react";
import { forwardRef } from "react";
import AdviceContainer from "./AdviceContainer";
import ErxHeader from "./ErxHeader";
import { DateFormat } from "../../Helper";
const ErxPrintable = forwardRef(function ErxPrintable(
  { bp, doctor, patient, adviceContainerProps, erxDate, erxId },
  ref
) {
  return (
    <div ref={ref}>
      <div className="d-flex justify-content-between">
        <h2>E-Prescription</h2>
        <span>
          Date:
          <DateFormat value={erxDate} />
        </span>
      </div>
      <ErxHeader bp={bp} doctor={doctor} patient={patient} />
      <AdviceContainer
        {...adviceContainerProps}
        extraData={{ ...bp, ...doctor, ...patient, erxId: erxId }}
      />
      <div className="d-flex justify-content-end mt-5 border-black">
        <h5 className="w-25 border-top text-center">{doctor.doctorName}</h5>
      </div>
    </div>
  );
});

export default ErxPrintable;
